<template>
  <div style="position: relative; width:960px">
    <el-breadcrumb separator=""
                   style="margin-top: 12px">
      <el-breadcrumb-item>开发支持</el-breadcrumb-item>
      <el-breadcrumb-item><img src="../assets/icon-bread-arrow.svg"
             alt=""></el-breadcrumb-item>
      <el-breadcrumb-item>地图匹配</el-breadcrumb-item>
    </el-breadcrumb>
    <anchor class="title-wrap"
            style="width:150px">
      <anchor-link href="#id-product-introduction"
                   title="产品介绍" />
      <anchor-link href="#id-application-scene"
                   title="适用场景" />
      <anchor-link href="#id-instructions-for-use"
                   title="使用说明" />
      <anchor-link href="#map-match"
                   title="地图匹配" />
      <anchor-link href="#map-match"
                   title="地图匹配" />
    </anchor>
    <div id="content-containter"
         style="width: 788px;">
      <h1>地图匹配</h1>
      <span class="time">最后更新时间：2022年01月10日</span>
      <h2 id="id-product-introduction">产品介绍</h2>
      <ul>
        <li>
          <p>
            地图匹配API是通过HTTP协议访问远程服务的接口，根据坐标点抓取道路，即根据给定的坐标点、车辆的方位角以及行驶速度，将用户的轨迹纠偏到路上，从而返回用户实际驾车经过的道路坐标。 </p>
        </li>
      </ul>
      <h2 id="id-application-scene">适用场景</h2>
      <p>
      <ul>
        <li>
          <p>
            用于将行车产生的轨迹坐标点匹配到道路上。
          </p>
        </li>
      </ul>
      </p>
      <h2 id="id-instructions-for-use">使用说明</h2>
      <p>
      <ul>
        <li>第一步，申请Web服务API类型Key；</li>
        <li>第二步，参考接口文档发起HTTP/HTTPS请求；</li>
        <li>第三步，接收请求返回的JSON数据。</li>
      </ul>
      </p>
      <div id="division-container">
        <h2 id="map-match">地图匹配</h2>
        <h3>
          <ul style="list-style-type:disc;list-style-position:inside;">
            <li>地图匹配API服务地址</li>
          </ul>
        </h3>
        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>
                  <p>URL</p>
                </th>
                <th>
                  <p>https://lbsapi.meituan.com/v1/mapmatch/driving?parameters</p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <p>请求方式</p>
                </td>
                <td>
                  <p>POST</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <h3 id="id-请求参数">
          <ul style="list-style-type:disc;list-style-position:inside;">
            <li>请求参数</li>
          </ul>
        </h3>
        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th colspan="2">
                  <p><strong>参数名</strong></p>
                </th>
                <th>
                  <p><strong>数据类型</strong></p>
                </th>
                <th width="138">
                  <p><strong>含义</strong></p>
                </th>
                <th>
                  <p><strong>规则说明</strong></p>
                </th>
                <th width="88">
                  <p><strong>是否必填</strong></p>
                </th>
                <th width="70">
                  <p><strong>缺省值</strong></p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="2">
                  <p>key</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>请求服务权限标识</p>
                </td>
                <td>
                  <p>用户申请到的Web服务API Key</p>
                </td>
                <td>
                  <p>是</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p>coordinates</p>
                </td>
                <td>
                  <p v-text="'array<coordinate>'"></p>
                </td>
                <td>
                  <p>坐标串（gc02坐标系）</p>
                </td>
                <td>
                  <p>至少传入2个点</p>
                </td>
                <td>
                  <p>是</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
              <tr>
                <td rowspan="5">
                  <p></p>
                </td>
                <td>
                  <p>lng</p>
                </td>
                <td>
                  <p>double</p>
                </td>
                <td>
                  <p>经度</p>
                </td>
                <td>
                  <p>小数点后最多6位</p>
                </td>
                <td>
                  <p>是</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>lat</p>
                </td>
                <td>
                  <p>double</p>
                </td>
                <td>
                  <p>纬度</p>
                </td>
                <td>
                  <p>小数点后最多6位</p>
                </td>
                <td>
                  <p>是</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>ag</p>
                </td>
                <td>
                  <p>double</p>
                </td>
                <td>
                  <p>角度</p>
                </td>
                <td>
                  <p>与正北方向的夹角<br>沿顺时针方向为正值，取值范围[0,360)</p>
                </td>
                <td>
                  <p>是</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>ts</p>
                </td>
                <td>
                  <p>long</p>
                </td>
                <td>
                  <p>时间</p>
                </td>
                <td>
                  <p>1970年到当前的秒数，定位发生时的时间戳</p>
                </td>
                <td>
                  <p>是</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>sp</p>
                </td>
                <td>
                  <p>double</p>
                </td>
                <td>
                  <p>速度</p>
                </td>
                <td>
                  <p>车辆移动速度，单位：<font data-size="14"
                          style="font-size:14px;line-height:22px">km/h</font>
                  </p>
                </td>
                <td>
                  <p>是</p>
                </td>
                <td>
                  <p>无</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <h3 id="id-返回结果参数说明">
          <ul style="list-style-type:disc;list-style-position:inside;">
            <li>返回结果参数说明</li>
          </ul>
        </h3>
        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th colspan="4">
                  <p><strong>名称</strong></p>
                </th>
                <th>
                  <p><strong>类型</strong></p>
                </th>
                <th width="125">
                  <p><strong>含义</strong></p>
                </th>
                <th>
                  <p><strong>规则说明</strong></p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="4">
                  <p>status</p>
                </td>
                <td>
                  <p>int</p>
                </td>
                <td>
                  <p>返回结果状态值</p>
                </td>
                <td style="background-color: rgb(255, 255, 255);vertical-align:top;">
                  <p>200为成功；其它为失败，失败原因请参阅<router-link :to="'/support/status'"
                                 style="color: #1890ff;">状态码说明</router-link>。</p>
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  <p>msg</p>
                </td>
                <td>
                  <p>string</p>
                </td>
                <td>
                  <p>状态描述</p>
                </td>
                <td style="background-color: rgb(255, 255, 255);vertical-align:top;">
                  <p>当status不是200时，msg会返回具体错误原因，否则返回“成功”。详情参阅<router-link :to="'/support/status'"
                                 style="color: #1890ff;">状态码说明</router-link>。</p>
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  <p>data</p>
                </td>
                <td>
                  <p>data</p>
                </td>
                <td>
                  <p>结果</p>
                </td>
                <td>
                  <p>绑路结果，可解析为json object的json string。</p>
                </td>
              </tr>
              <tr>
                <td rowspan="6">
                  <p></p>
                </td>
                <td colspan="3">
                  <p>distance</p>
                </td>
                <td>
                  <p>double</p>
                </td>
                <td>
                  <p>道路总长度</p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <p>points</p>
                </td>
                <td>
                  <p v-text="'array<point>'"></p>
                </td>
                <td>
                  <p>返回坐标集</p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td rowspan="4">
                  <p></p>
                </td>
                <td colspan="2">
                  <p>point</p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td rowspan="3">
                  <p></p>
                </td>
                <td>
                  <p>lng</p>
                </td>
                <td>
                  <p>double</p>
                </td>
                <td>
                  <p>经度</p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>lat</p>
                </td>
                <td>
                  <p>double</p>
                </td>
                <td>
                  <p>纬度</p>
                </td>
                <td>
                  <p></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>ts</p>
                </td>
                <td>
                  <p>long</p>
                </td>
                <td>
                  <p>定位发生时的时间戳，<br>1970.1.1至今的毫秒数</p>
                </td>
                <td>
                  <p>当作为入参时，会根据时间戳计算相对速度等</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <h3 id="id-服务示例">
          <ul style="list-style-type:disc;list-style-position:inside;">
            <li>服务示例</li>
          </ul>
        </h3>
        <p><strong>body中的参数</strong></p>
        <div class="service-example">
          <pre><p ><code id="json"></code></p></pre>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import '@ss/mtd-vue/lib/theme2/anchor.css'
import '@ss/mtd-vue/lib/theme2/anchor-link.css'
import Anchor from '@/views/support/anchor/anchor.vue'
import AnchorLink from '@/views/support/anchor/anchor-link.vue'
export default {
  components: {
    Anchor,
    AnchorLink
  },
  data() {
    return {
      jsonData: {
        key: '用户的key',
        coordinates: [
          {
            lng: 116.65082,
            lat: 40.12996,
            ag: 14.1414,
            ts: 1603349709423,
            sp: -1
          },
          {
            lng: 116.65086,
            lat: 40.12999,
            ag: 14.1414,
            ts: 1603349709423,
            sp: -1
          },
          {
            lng: 116.65082,
            lat: 40.12996,
            ag: 14.1414,
            ts: 1603349709423,
            sp: -1
          },
          {
            lng: 116.65082,
            lat: 40.12996,
            ag: 14.1414,
            ts: 1603349709423,
            sp: -1
          },
          {
            lng: 116.65082,
            lat: 40.12996,
            ag: 14.1414,
            ts: 1603349709423,
            sp: -1
          },
          {
            lng: 116.65082,
            lat: 40.12996,
            ag: 14.1414,
            ts: 1603349709423,
            sp: -1
          }
        ]
      }
    }
  },
  mounted() {
    let btn = document.querySelector('#json')
    btn.textContent = JSON.stringify(this.jsonData, null, '  ')
  }
}
</script>
<style lang="less" scoped>
@import '../document.less';

.title-wrap {
  // right: calc(50vw - 590px);
  // float: right;
  position: absolute;
  right: 0px;
  top: 100px;
  .mtd-anchor .mtd-anchor-link {
    font-size: 14px !important;
  }
}

/deep/.mtd-anchor-link-active .mtd-anchor-link-title {
  color: #a46e00 !important;
  font-weight: 600;
  font-family: PingFangSC-Semibold;
}
/deep/.title-wrap .mtd-anchor-ink-ball {
  background-color: #ffd100 !important;
}
/deep/ .mtd-anchor-link-title:hover {
  color: #a46e00;
  font-weight: 600;
  font-family: PingFangSC-Semibold;
}
</style>
